import React from "react";
import InternalLink from "./InternalLink";

import "./ReadMoreWrapper.css";

type Props = {
  href: string;
  lexicon: {
    readMore: string;
  };
  htmlTruncated: string;
  messageTitle: string;
};

export default function ReadMoreWrapper({
  href,
  lexicon,
  htmlTruncated,
  messageTitle,
}: Props) {
  return (
    <div className="ReadMoreWrapper">
      <article
        className="max-w-lg mx-auto"
        dangerouslySetInnerHTML={{ __html: htmlTruncated }}
      ></article>
      <InternalLink
        data-cy="readmore-link"
        href={href}
        className="ReadMoreWrapper__link"
        aria-label={`${lexicon.readMore}: ${messageTitle}`}
      >
        {lexicon.readMore}
      </InternalLink>
    </div>
  );
}
